// extracted by mini-css-extract-plugin
module.exports = {"glazing":"Collapsible_glazing__4Bseu","glaze":"Collapsible_glaze__mwoOC"};